<template>
  <v-container>
    <v-radio-group dark v-model="value" class="controlled-font">
      <v-radio
        class="pa-3 rounded white--text controlled-font text-uppercase"
        :class="option.key !== value ? 'primary' : 'secondary'"
        v-for="option in options"
        :key="option.key"
        :label="String(option.text)"
        :value="option.key"
        @click="updateValue(option.key)"
        :style="spacing"
      >
      </v-radio>
    </v-radio-group>
  </v-container>
</template>

<script>
export default {
  created() {},
  props: {
    options: {
      type: [Array],
      required: true,
    },
    buttonSpacing: Number,
    selection: String,
  },
  data() {
    return {
      value: null,
    };
  },
  methods: {
    updateValue(value) {
      this.value = value;
      console.log(`Selected Value: ${value}`);
      this.$emit("change", value);
    },
    clearSelection() {
      this.value = "";
    },
  },
  computed: {
    spacing() {
      return "margin-bottom:" + (this.buttonSpacing || 15) + "px;";
    },
  },
  watch: {
    selection(newValue, oldValue) {
      if (oldValue != newValue) {
        this.value = newValue;
      }
    },
  },
};
</script>

<style scoped>
.white--text /deep/ label {
  color: white;
  font-size: 14pt;
}

.white--radio /deep/ input {
  color: white;
}
</style>
